//import axios from "axios"
import { DB } from '../config/firebaseConfig'
import { collection, query, where, orderBy, getDocs, doc, getDoc } from "firebase/firestore"


export const updateCart = ({
  commit
}, {item, quantity, isAdd}) => {
  // TODO: Call service
  commit('UPDATE_CART', {item, quantity, isAdd});
  if (isAdd) {
    let message_obj = {
      message: `Added ${item.title} to cart successfully`,
      messageClass: "success",
      autoClose: true
    }
    commit('ADD_MESSAGE', message_obj);
  }
}

export const removeItemInCart = ({commit}, {item}) => {
	commit('REMOVE_CART_ITEM', {item});
}

/*
export const registerByEmail = (_, {email, password}) => {
	return firebaseAuth().createUserWithEmailAndPassword(email, password);
}

export const logout = ({commit}) => {
  commit('SET_CART', []); // clear current cart
  return firebaseAuth().signOut();
}

export function loginWithEmail (_, {email, password}) {
  return firebaseAuth().signInWithEmailAndPassword(email, password);
}
*/

export async function listenToProductList({commit}, {orgId, location}) {
	commit('UPDATE_ORG_ID', orgId)
	if (orgId == "1")
		commit('UPDATE_ORG_NAME', 'Ketco')
	else
		commit('UPDATE_ORG_NAME', orgId)
	commit('UPDATE_LOCATION', location)

	const q = query(collection(DB, "Org", orgId, "Item1"), where("onlineSale", "==", true), orderBy("order"))
	var items = []
	var i = 0

	const querySnapshot = await getDocs(q)
	querySnapshot.forEach((doc) => {
	  // doc.data() is never undefined for query doc snapshots
	  //console.log(doc.id, " => ", doc.data())
	  items[i] = doc.data()
	  i = i + 1
	})
	// Sort by order
	commit('UPDATE_ITEM1_LIST', items)
	// Update Auth Status
	//commit('AUTH_STATUS_CHANGE')

    //Get StoreUI config data from DB
    const docRef = doc(DB, "Org", orgId, "Config", "OnlineStoreSetup")
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
		let websiteLink = docSnap.data().websiteLink
		let gProfileLink = docSnap.data().gProfileLink
		let showProducts = docSnap.data().showProducts
		let showMessages = docSnap.data().showMessages
		let showWholesalers = docSnap.data().showWholesalers
		let showPrices = docSnap.data().showPrices
		let dealerClassLevel = docSnap.data().dealerClassLevel
		let dealerOrderLevel = docSnap.data().dealerOrderLevel
		commit('UPDATE_STORE_UI', {websiteLink, gProfileLink, showProducts, showMessages, 
								   showWholesalers, showPrices, dealerClassLevel, dealerOrderLevel})
    } else {
      // docSnap.data() will be undefined in this case
      self.addMessage({messageClass: 'error', message: 'Store Config missing!',})
    }

}

/*
export function listenToProductList({commit}, {orgId, location}) {
	commit('UPDATE_ORG_ID', orgId)
	commit('UPDATE_LOCATION', location)
	return ref.child(orgId).on('value', (orgInfo) => {
		commit('UPDATE_ITEM1_LIST', orgInfo.val().itemsOnline)
		commit('UPDATE_ORG_NAME', orgInfo.val().name)
	});
}

export function listenToProductList_Old({commit}, {orgId}) {
	//var orgId = new URL(location.href).searchParams.get('org')
	commit('UPDATE_ORG_ID', orgId)
	var formData = new FormData()
	formData.append('orgId', orgId)

	axios({
		method: 'POST',
		baseURL: process.env.VUE_APP_ROOT_API,
		url: '/GetItem1sOnlineStore/',
		data: formData,
		headers: {
			'Authorization': 'Bearer ',
			'OrgId': '',
			'Content-Type': 'multipart/form-data',
		},
	})
	.then(function (response) {
		if (response.data.err != ''){
			commit('ADD_MESSAGE', {messageClass: "warning", message: response.data.err})
		}
		else {
			console.log(JSON.stringify(response.data.item1List))
			commit('UPDATE_ITEM1_LIST', response.data.item1List)
			commit('UPDATE_ORG_NAME', response.data.orgName)
		}
	})
	.catch(function (error) {
		commit('ADD_MESSAGE', {messageClass: "danger", message: String(error)})
	})
}
*/




// export function submitOrderTo({commit}, {orgId, cartItemList, cartValue, buyer}) {
// 	Notification.requestPermission().then((permission) => {
// 		if (permission === 'granted') {
// 			getToken(messaging, {"vapidKey": "BJQ4_6tTBekShmnpiZkrDTxbB9BXLBnCLaeEnfTn0iZ1sUUI0d2yZZ877Vl7mO9z-BMJBCi_t4F79AdHaWNsugk"})
// 			.then(function(token){
// 				submitOrderWithToken({commit}, {orgId, cartItemList, cartValue, buyer, token})
// 			})
// 		}
// 		else {
// 			let token = ''
// 			submitOrderWithToken({commit}, {orgId, cartItemList, cartValue, buyer, token})
// 		}
// 	})
// }

// export async function submitOrder({commit}, {orgId, cartItemList, cartValue, buyer}) {
// 	commit('ADD_MESSAGE', {messageClass: "warning", message: "Please wait, processing..."})

// 	var partner = 
// 	{
// 	  nbr: '',
// 	  type: 'Customer',
// 	  name: buyer.name,
// 	  phone: buyer.phone,
// 	  GSTN: '',
// 	  state: buyer.state,
// 	  inState: 'No',
// 	  address1: '',
// 	  address2: '',
// 	  address3: '',
// 	  transporter: '',
// 	  transportDest: '',
// 	  note: '',
// 	  vgtSelected: false
// 	}

// 	// Create Order Object
// 	var order = {
// 		'nbr': null,
// 		'type': 'Sale',
// 		'location': 'Online',
// 		'items': [],
// 		'status': 0,
// 		'note': '',
// 		'tax': 0,
// 		'total': cartValue,
// 		'total1': cartValue,
// 		'total2': 0,
//         'invoiceIssued': 'No',
//         'GSTN': '',
//         'altNbr': '',
// 		'inState': 'No',
// 		'createDate': null,
// 		'paid': 'No',
// 		'invoiceDate': null,
// 		'curPayDate': null,
// 		'curPayType': 'Bank',
// 		'curPayAmt': 0,
// 		'payInstructions': '',
// 		'payments': [],
// 		'paidSoFar': 0,
// 		'outstanding': 0,
// 		'delivered': 'No',
// 		'deliveryDate': null,
// 		'deliveryReady': 'No',
// 		'cancelled': 'No',
// 		'cancelledDate': null,
// 		'updateDate': null,
// 		'partner': partner,
// 	  }

// 	var currentDate = new Date()
// 	currentDate.setHours(12)
// 	currentDate.setMinutes(0)
// 	currentDate.setSeconds(0)
// 	currentDate.setMilliseconds(0)
// 	order.createDate = currentDate
// 	order.updateDate = currentDate

// 	// Add Items
// 	var items = []
// 	var orderTax = 0
// 	var orderTotal = 0
// 	for (let i = 0; i < cartItemList.length; i++) {
// 		let item = {}
// 		item.name = cartItemList[i].name
// 		item.item1Name = cartItemList[i].item1Name
// 		item.price = cartItemList[i].price
// 		item.cost = 0
// 		item.qty = cartItemList[i].quantity
// 		item.tax = (cartItemList[i].price * (cartItemList[i].taxrate / 100) * cartItemList[i].quantity)
// 		item.tax = parseFloat(item.tax.toFixed(2))
// 		item.surcharge = 0
// 		item.discount = 0
// 		item.minSalesTax = 0
// 		item.total = (cartItemList[i].price * (1 + cartItemList[i].taxrate / 100) * cartItemList[i].quantity)
// 		item.total = parseFloat(item.total.toFixed(2))
// 		item.CGST = {'amt': 0, 'apply': 'No'}
// 		item.SGST = {'amt': 0, 'apply': 'No'}
// 		item.IGST = {'amt': item.tax, 'apply': 'Yes'}
// 		orderTax = orderTax + item.tax
// 		orderTotal = orderTotal + item.total
// 		items.push(Object.assign({}, item))
// 	}
// 	order['items'] = items
// 	order['tax'] = orderTax
// 	order['total'] = orderTotal

// 	// var formData = new FormData()
// 	// formData.append('orgId', orgId)
// 	// formData.append('order', JSON.stringify(order))

// 	const tokens = await anonSignIn()
// 	if (tokens.auth == ''){
// 		self.addMessage({messageClass: 'error', message: "Invalid User",})
// 		return
// 	}

// 	const postJson = {
// 		'orgId': orgId,
// 		'order': order,
// 		'nToken': tokens.notification
// 	}

// 	axios({
// 		method: 'POST',
// 		baseURL: process.env.VUE_APP_ROOT_API,
// 		url: '/SaveOrderOnline/',
// 		data: postJson,
// 		headers: {
// 			'Authorization': 'Bearer ' + tokens.auth,
// 			'OrgId': '',
// 			'Content-Type': 'application/json',
// 		},
// 	})
// 	.then(function (response) {
// 		if (response.data.err != ''){
// 			commit('ADD_MESSAGE', {messageClass: "warning", message: response.data.err})
// 		}
// 		else {
// 			commit('ADD_MESSAGE', {messageClass: "success", message: "Order Submitted. Seller will contact you soon."})
// 			// Clear Shopping Cart
// 			commit('SET_CART', [])
// 			commit('CLEAR_BUYER')
// 		}
// 	})
// 	.catch(function (error) {
// 		commit('ADD_MESSAGE', {messageClass: "danger", message: String(error)})
// 	})
// }


export function getItem2List({commit}, {item1Name}) {
	commit('UPDATE_ITEM2_LIST', item1Name)
	commit('UPDATE_SHOW_ITEM_LEVEL', 2)
}

/*
export function getShoppingCart({commit}, {uid, currentCart}) {
	if (uid) {
		return ref.child("cart/" + uid).once('value').then((cart) => {
			// console.log(cart.val());
			if (cart.val() && (!currentCart || currentCart.length == 0)) {
				commit('SET_CART', cart.val());
			}
		});
	} else {
		// console.log("User has not logged in");
	}
}

export function saveShoppingCart(_, {uid, cartItemList}) {
	// console.log("ACTIONS saveShoppingCart");
	// console.log("CART DATA", cartItemList);
	return ref.child("cart/" + uid).set(cartItemList);
}

export function saveToTransaction(_, {uid, cartItemList}) {
	let newTransactionKey = ref.child("transactions").push().key;
	var newTransaction = {}
	newTransaction['/transactions/' + uid + '/' + newTransactionKey] = cartItemList;
	return ref.update(newTransaction);
}
*/
